import React from 'react'
import { GatsbyImage as Image, getImage } from 'gatsby-plugin-image'
import { renderContent } from '../../utilities/renderContent'
import { formatDate } from "../../utilities/formatDate";
import { Link } from 'gatsby'

export default function BlogPost({ data }) {
  return (
    <section className="BlogPost hds-container hds-text-color -mt-4">
      <div className="flex flex-col md:flex-row md:justify-around bg-white p-4">
        <div className="w-full md:w-2/6">
          <Image
            image={getImage(data.blogPost.featuredImage)}
            alt={`blog post`}
            className="object-center w-full object-contain rounded"
          />
        </div>
        <div className="font-a1 text-thermaGrey-lighter w-full md:w-7/12 pt-4 md:pt-0" id="newsletter-subscription">
          <Link to={`/blogs/tick-blog/${data.blogPost.postTitle.split(" ").join("-").toLowerCase()}` }>
            <h4 className="font-heading text-2xl text-tickProGreen">{data.blogPost.postTitle}</h4>
          </Link>
          <span className="text-sm">{formatDate(data.blogPost.meta.firstPublishedAt)}</span>
          <div dangerouslySetInnerHTML={renderContent(data.blogPost.excerpt)} />
        </div>
      </div>
    </section>
  )
}
